import React, { useCallback } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useResetRecoilState } from 'recoil'

import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
  SpacingVertical,
  SPACING_32,
  SPACING_24
} from 'mailup-web-components'

import { modalSaveAsTemplateState } from '../recoil/state/modals'

import InputTitle from './InputTitle'
import InputLists from './InputLists'

import { beePluginState } from 'Pages/MessageEdit/recoil/state/editor'

const ModalSave = () => {
  const intl = useIntl()

  const { instance: beePluginInstance } = useRecoilValue(beePluginState)

  const { show, title, saveToLists, selectAll, lists } = useRecoilValue(
    modalSaveAsTemplateState
  )

  const validate = values =>
    values.title.trim().length > 0 &&
    (values.selectAll ? lists.length > 0 : values.saveToLists.length > 0)

  const valid = validate({ title, saveToLists, selectAll, lists })

  const handleClose = useResetRecoilState(modalSaveAsTemplateState)

  const handleSave = useCallback(() => {
    beePluginInstance.saveAsTemplate()
  }, [beePluginInstance])

  return (
    <Modal
      show={show}
      showClose
      onClose={handleClose}
      data-mu-test='modal-template-save'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ModalTitleForTemplate'
        })}
      />
      <ModalBody>
        <Text>
          {intl.formatMessage({
            id: 'Load.Bee.SelectListsDescription'
          })}
        </Text>
        <SpacingVertical variant={SPACING_32} />

        <InputTitle />
        <SpacingVertical variant={SPACING_24} />
        <InputLists />
      </ModalBody>
      <ModalFoot>
        <Button onClick={handleClose} kind='secondary'>
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
        <Button onClick={handleSave} kind='primary' disabled={!valid}>
          {intl.formatMessage({ id: 'Load.Bee.ModalSave' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalSave
